module.exports = __webpack_public_path__ + "img/3.5821fb4e.png";